import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {Draggable} from 'gsap/Draggable';

'use strict';
const SliderCircle = {
	init: function() {
		gsap.registerPlugin(Draggable, ScrollTrigger);

		//const descriptions = gsap.utils.toArray('.js-circle-slider-descriptions .js-circle-slider-content');
		const items = gsap.utils.toArray('.js-circle-slider-slide .js-circle-slider-inner');

		//gsap.set(descriptions[0], {autoAlpha: 1});// The first description visible.

		const carousel = buildCarousel(items, {
			radiusX: 690,
			radiusY: 570,
			activeAngle: -90,
			draggable: true,
			autoAdvance: 2,
			onClick(element, self) {
				self.to(element, {duration: 1, ease: 'power1.inOut'}, 'short');
			},
			onActivate(element) {
				element.classList.add('active');
			},
			onDeactivate(element) {
				element.classList.remove('active');
			},
			// when a drag or animation starts (via the Carousel's to()/next()/previous() methods)
			// onStart(element) {
			// 	gsap.to(descriptions[items.indexOf(element)], {autoAlpha: 0, duration: 0.25, overwrite: 'auto'});
			// },
			// onStop(element) {
			// 	gsap.to(descriptions[items.indexOf(element)], {autoAlpha: 1, overwrite: 'auto'});
			// }
		});

		// const nextButton = document.querySelector('.js-circle-slider-next');
		// const prevButton = document.querySelector('.js-circle-slider-previous');
		// if (prevButton) {
		// 	prevButton.addEventListener('click', () => carousel.previous());
		// }
		// if (nextButton) {
		// 	nextButton.addEventListener('click', () => carousel.next());
		// }

		// RESPONSIVE
		ScrollTrigger.matchMedia({
			'(max-width: 1600px)': () => {
				carousel.resize(580, 480);
			},
			'(max-width: 1330px)': () => {
				carousel.resize(480, 390);
			},
			'(max-width: 1200px)': () => {
				carousel.resize(440, 370);
			},
			'(max-width: 1199px)': () => {
				carousel.resize(370, 290);
			},
			'(max-width: 1000px)': () => {
				carousel.resize(370, 290);
			},
			'(max-width: 999px)': () => {
				carousel.resize(270, 220);
			},
			'(max-width: 770px)': () => {
				carousel.resize(0, 150);
			}
		});

		function buildCarousel(targets, {radiusX = 200, radiusY = 200, activeAngle = -90, activeElement, onClick, onActivate, onDeactivate, onStart, onStop, draggable, autoAdvance}) {
			targets = gsap.utils.toArray(targets);
			gsap.set(targets, {xPercent: -50, x: 0, yPercent: -50, y: 0});
			const DEG2RAD = Math.PI / 180;
			// eslint-disable-next-line
			let eventTypes = ('ontouchstart' in document.documentElement ? 'touchstart,touchmove,touchcancel,touchend' : !('onpointerdown' in document.documentElement) ? 'mousedown,mousemove,mouseup,mouseup' : 'pointerdown,pointermove,pointercancel,pointerup').split(',');
			const round = value => Math.round(value * 10000) / 10000;
			const tempDiv = document.createElement('div');
			const quantity = targets.length;
			const angleInc = 360 / quantity;
			const wrap = gsap.utils.wrap(0, quantity);
			const angleWrap = gsap.utils.wrap(0, 360);
			let rotation = 0;
			let dragged;
			let onPressRotation;
			const autoAdvanceCall = autoAdvance && gsap.delayedCall(parseFloat(autoAdvance) || 2, () => { self.next(); autoAdvanceCall.restart(true); });
			const xSetters = targets.map(el => gsap.quickSetter(el, 'x', 'px'));
			const ySetters = targets.map(el => gsap.quickSetter(el, 'y', 'px'));
			// eslint-disable-next-line
			let self = {
					rotation(value) {
						if (arguments.length) {
							const prevActive = activeElement;
							rotation = angleWrap(value);
							activeElement = targets[wrap(Math.round(-value / angleInc))];
							self.render();
							if (prevActive !== activeElement) {
								onDeactivate && prevActive && onDeactivate(prevActive, self);
								onActivate && onActivate(activeElement, self);
							}
						}
						return rotation;
					},
					resize(rx, ry) {
						radiusX = rx;
						radiusY = ry;
						self.render();
					},
					render() {
						const inc = angleInc * DEG2RAD;
						let a = (rotation + activeAngle) * DEG2RAD;
						let i = 0;
						for (; i < quantity; i++) {
							xSetters[i](round(Math.cos(a) * radiusX));
							ySetters[i](round(Math.sin(a) * radiusY));
							a += inc;
						}
					},
					activeElement(value) {
						if (arguments.length) {
							self.rotation(self.elementRotation(value));
						}
						return activeElement;
					},
					elementRotation(element) {
						const index = targets.indexOf(gsap.utils.toArray(element)[0]);
						return (quantity - index) * angleInc;
					},
					to(elOrRotation, vars, direction) {
						vars = vars || {};
						vars.rotation = typeof(elOrRotation) === 'number' ? elOrRotation : (self.elementRotation(elOrRotation) || parseFloat(elOrRotation));
						vars.overwrite = true;
						const {onUpdate, onComplete} = vars;
						const _onStart = vars.onStart;
						autoAdvanceCall && autoAdvanceCall.pause();
						vars.onStart = function() {
							onStart && onStart(activeElement, self);
							_onStart && _onStart.call(this);
						};
						vars.onComplete = function() {
							onStop && onStop(activeElement, self);
							onComplete && onComplete.call(this);
							autoAdvanceCall && autoAdvanceCall.restart(true);
						};
						if (direction) {
							const getter = gsap.getProperty(tempDiv);
							vars.onUpdate = function() {
								self.rotation(getter('rotation'));
								onUpdate && onUpdate.call(this);
							};
							vars.rotation += '_' + direction;
							return gsap.fromTo(tempDiv, {rotation: rotation}, vars);
						}
						return gsap.to(self, vars);
					},
					next(vars, direction) {
						const element = targets[wrap(targets.indexOf(activeElement) + 1)];
						self.to(element, vars, direction || 'ccw');
					},
					previous(vars, direction) {
						const element = targets[wrap(targets.indexOf(activeElement) - 1)];
						self.to(element, vars, direction || 'cw');
					},
					kill() {
						targets.forEach(el => {
							el.removeEventListener('click', _onClick);
							el.removeEventListener(eventTypes[0], onPress);
							el.removeEventListener(eventTypes[2], onRelease);
							el.removeEventListener(eventTypes[3], onRelease);
						});
						gsap.killTweensOf(self);
						tempDiv.parentNode && tempDiv.parentNode.removeChild(tempDiv);
						autoAdvanceCall && autoAdvanceCall.kill();
						draggable && draggable.kill();
					},
					autoAdvance: autoAdvanceCall
				},
				// eslint-disable-next-line
				_onClick = e => {
					if (!dragged) {
						autoAdvanceCall && autoAdvanceCall.restart(true);
						onClick && onClick(e.currentTarget, self);
					}
				},
				// eslint-disable-next-line
				onPress = e => {
					onPressRotation = rotation;
					gsap.set(tempDiv, {rotation: rotation});
					autoAdvanceCall && autoAdvanceCall.pause();
					gsap.killTweensOf(self);
					draggable.startDrag(e);
					dragged = false;
				},
				// eslint-disable-next-line
				onRelease = e => {
					draggable.endDrag(e);
					if (rotation === onPressRotation) {
						autoAdvanceCall && autoAdvanceCall.restart(true);
						draggable.tween && draggable.tween.kill();
						_onClick(e);
					}
				},
				// eslint-disable-next-line
				syncDraggable = () => {
					if (!dragged) {
						onStart && onStart(activeElement, self);
						dragged = true;
					}
					self.rotation(draggable.rotation);
				};
			if (targets.length) {
				targets[0].parentNode.appendChild(tempDiv);
			}
			gsap.set(tempDiv, {visibility: 'hidden', position: 'absolute', width: 0, height: 0, top: '50%', left: '50%', xPercent: -50, yPercent: -50});
			targets.forEach(el => {
				el.addEventListener('click', _onClick);
			});

			self.snap = angleInc;
			draggable && (self.draggable = draggable = Draggable.create(tempDiv, {type: 'rotation', snap: gsap.utils.snap(angleInc), inertia: true, onThrowComplete: () => {autoAdvanceCall && autoAdvanceCall.restart(true); onStop && onStop(activeElement, self);}, onThrowUpdate: syncDraggable, onDrag: syncDraggable})[0]);
			self.activeElement(gsap.utils.toArray(activeElement)[0] || targets[0]);
			return self;
		}
	},
};

export default SliderCircle;
